/** Base path do console master (prefixo da rota React). */
export const PLATFORM_CONSOLE_BASE = "/platform/xprobase";

/** Path do console master (inclui subrotas). */
export function isPlatformConsolePath(pathname = "") {
  const p = String(pathname || "");
  return p === PLATFORM_CONSOLE_BASE || p.startsWith(`${PLATFORM_CONSOLE_BASE}/`);
}

/** Segmentos de URL para cada área do console (nível superior). */
export const PLATFORM_CONSOLE_SEGMENT = {
  workspaces: "workspaces",
  /** Mesmo padrão do portal do representante: página dedicada ao assistente de criação. */
  workspaceCreate: "workspaces/new",
  opportunities: "opportunities",
  /** Visão geral do repasse WhatsApp Out/2026 (ACL de workspaces). */
  whatsappOut2026: "whatsapp-out-2026",
  insights: "insights",
  productUsage: "product-usage",
  internalAsk: "internal-ask",
  passengerTicketSales: "passenger-ticket-sales",
  presence: "presence",
  segments: "segments",
  governance: "governance",
  catalog: "catalog",
  chatbotTemplates: "chatbot-templates",
  team: "team",
  dashboard: "dashboard",
  pendingActions: "pending-actions",
  platformErrors: "platform-errors",
  /** Diagnóstico ops; ACL reutiliza platform-errors (view). */
  dbPressure: "db-pressure",
  apifacilInstances: "apifacil-instances",
  finance: "finance",
  /** Resultados pessoais de comissão/bônus (visível só se cadastrado em Pessoas). */
  myIncentives: "my-incentives",
};

/** Rotas absolutas por área. */
export const PLATFORM_CONSOLE_PATH = {
  workspaces: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaces}`,
  workspaceCreate: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaceCreate}`,
  opportunities: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.opportunities}`,
  whatsappOut2026: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.whatsappOut2026}`,
  insights: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.insights}`,
  productUsage: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.productUsage}`,
  internalAsk: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.internalAsk}`,
  passengerTicketSales: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.passengerTicketSales}`,
  presence: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.presence}`,
  segments: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.segments}`,
  governance: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.governance}`,
  catalog: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.catalog}`,
  chatbotTemplates: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.chatbotTemplates}`,
  team: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.team}`,
  dashboard: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.dashboard}`,
  pendingActions: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.pendingActions}`,
  platformErrors: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.platformErrors}`,
  dbPressure: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.dbPressure}`,
  apifacilInstances: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.apifacilInstances}`,
  finance: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}`,
  myIncentives: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.myIncentives}`,
  financeStatements: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/statements`,
  financeLedger: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/ledger`,
  financeIndicators: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/indicators`,
  financePlanning: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/planning`,
  financeIncentives: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/incentives`,
  financeCommissions: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/commissions`,
  financeSetup: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/setup`,
  /** Aliases das URLs antigas (redirect na página). */
  financeDre: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/statements`,
  financeClientMargins: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/indicators`,
  financeGoals: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/planning`,
  financeEvolution: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/statements`,
  financeValuation: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/planning`,
  /** Simulador de preços — só em Catálogo e operações. */
  financePriceComposition: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.catalog}?area=composer`,
  catalogComposer: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.catalog}?area=composer`,
  financeCashFlow: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/statements`,
  financeBalance: `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.finance}/statements`,
};

export const FINANCE_GROUP_SLUGS = [
  "statements",
  "ledger",
  "indicators",
  "planning",
  "commissions",
  "incentives",
  "setup",
];

export const FINANCE_GROUP_VIEWS = {
  statements: ["dre", "cash-flow", "balance", "evolution"],
  ledger: ["entries", "reconcile", "accounts"],
  indicators: ["saas", "clients"],
  planning: ["goals", "valuation"],
  commissions: ["sales", "team-rules", "portfolio", "channel-rules", "month-report"],
  incentives: ["corporate", "people", "cards", "bonus"],
  setup: ["account-map"],
};

export const FINANCE_GROUP_DEFAULT_VIEW = {
  statements: "dre",
  ledger: "entries",
  indicators: "saas",
  planning: "goals",
  commissions: "sales",
  incentives: "corporate",
  setup: "account-map",
};

/** Deep link `/finance/{group}?view=`. */
export function financePath(group, view) {
  const g = FINANCE_GROUP_SLUGS.includes(group) ? group : "statements";
  const base = `${PLATFORM_CONSOLE_PATH.finance}/${g}`;
  const allowed = FINANCE_GROUP_VIEWS[g] || [];
  if (view && allowed.includes(view)) return `${base}?view=${encodeURIComponent(view)}`;
  return base;
}

const LEGACY_FINANCE_TAB_TO_GROUP = {
  dre: { group: "statements", view: "dre" },
  "cash-flow": { group: "statements", view: "cash-flow" },
  balance: { group: "statements", view: "balance" },
  evolution: { group: "statements", view: "evolution" },
  "client-margins": { group: "indicators", view: "clients" },
  goals: { group: "planning", view: "goals" },
  valuation: { group: "planning", view: "valuation" },
  "price-composition": { group: "setup", view: "prices" },
  "account-map": { group: "setup", view: "account-map" },
  channel: { group: "commissions", view: "portfolio" },
};

/** Slug de :tab legado → grupo + view canônicos. Grupos novos retornam null (não redirecionar). */
export function resolveFinanceLegacyTab(tabSlug) {
  const s = String(tabSlug || "")
    .trim()
    .toLowerCase();
  return LEGACY_FINANCE_TAB_TO_GROUP[s] || null;
}

/** Slug de seção ACL (kebab) → path absoluto do menu. */
export const PLATFORM_CONSOLE_SECTION_PATH = {
  [PLATFORM_CONSOLE_SEGMENT.workspaces]: PLATFORM_CONSOLE_PATH.workspaces,
  [PLATFORM_CONSOLE_SEGMENT.opportunities]: PLATFORM_CONSOLE_PATH.opportunities,
  [PLATFORM_CONSOLE_SEGMENT.insights]: PLATFORM_CONSOLE_PATH.insights,
  [PLATFORM_CONSOLE_SEGMENT.dashboard]: `${PLATFORM_CONSOLE_PATH.dashboard}/live`,
  [PLATFORM_CONSOLE_SEGMENT.productUsage]: PLATFORM_CONSOLE_PATH.productUsage,
  [PLATFORM_CONSOLE_SEGMENT.internalAsk]: PLATFORM_CONSOLE_PATH.internalAsk,
  [PLATFORM_CONSOLE_SEGMENT.passengerTicketSales]: PLATFORM_CONSOLE_PATH.passengerTicketSales,
  [PLATFORM_CONSOLE_SEGMENT.presence]: PLATFORM_CONSOLE_PATH.presence,
  [PLATFORM_CONSOLE_SEGMENT.segments]: PLATFORM_CONSOLE_PATH.segments,
  [PLATFORM_CONSOLE_SEGMENT.governance]: PLATFORM_CONSOLE_PATH.governance,
  [PLATFORM_CONSOLE_SEGMENT.catalog]: PLATFORM_CONSOLE_PATH.catalog,
  [PLATFORM_CONSOLE_SEGMENT.chatbotTemplates]: PLATFORM_CONSOLE_PATH.chatbotTemplates,
  [PLATFORM_CONSOLE_SEGMENT.pendingActions]: PLATFORM_CONSOLE_PATH.pendingActions,
  [PLATFORM_CONSOLE_SEGMENT.platformErrors]: PLATFORM_CONSOLE_PATH.platformErrors,
  [PLATFORM_CONSOLE_SEGMENT.apifacilInstances]: PLATFORM_CONSOLE_PATH.apifacilInstances,
  [PLATFORM_CONSOLE_SEGMENT.finance]: PLATFORM_CONSOLE_PATH.financeStatements,
};

/** Path absoluto de uma aba do dashboard consolidado da plataforma. */
export function platformDashboardTabPath(tabKey) {
  const key = String(tabKey || "live").trim() || "live";
  return `${PLATFORM_CONSOLE_PATH.dashboard}/${encodeURIComponent(key)}`;
}

export function isConsoleTeamPath(pathname) {
  return pathname === PLATFORM_CONSOLE_PATH.team || pathname.startsWith(`${PLATFORM_CONSOLE_PATH.team}/`);
}

/**
 * Slugs antigos em ?tab= (platformConsoleTabs) → caminho destino.
 * Presença unifica "online" e "workspaces-online" com query ?view=
 */
export function legacyTabSlugToPath(tabSlug) {
  const s = String(tabSlug || "")
    .trim()
    .toLowerCase();
  const map = {
    workspaces: PLATFORM_CONSOLE_PATH.workspaces,
    analytics: PLATFORM_CONSOLE_PATH.insights,
    opportunities: PLATFORM_CONSOLE_PATH.opportunities,
    online: `${PLATFORM_CONSOLE_PATH.presence}?view=operators`,
    "workspaces-online": `${PLATFORM_CONSOLE_PATH.presence}?view=workspaces`,
    segments: PLATFORM_CONSOLE_PATH.segments,
    governance: PLATFORM_CONSOLE_PATH.governance,
    catalog: PLATFORM_CONSOLE_PATH.catalog,
    "chatbot-templates": PLATFORM_CONSOLE_PATH.chatbotTemplates,
  };
  return map[s] || PLATFORM_CONSOLE_PATH.workspaces;
}

/** Seções do detalhe do workspace (URL :section), ordem = índice da tab interna legada. */
export const WORKSPACE_DETAIL_SECTION_SLUGS = [
  "overview",
  "health",
  "usage",
  "invoices",
  "offers",
  "segment",
  "plan",
  "audit",
  "superlogica",
  "passenger-sales",
  "gupshup-reconcile",
  "whatsapp-pricing",
];

export function workspaceDetailSectionToIndex(section) {
  const s = String(section || "")
    .trim()
    .toLowerCase();
  const i = WORKSPACE_DETAIL_SECTION_SLUGS.indexOf(s);
  return i >= 0 ? i : 0;
}

export function workspaceDetailIndexToSection(index) {
  const i = Number(index);
  if (!Number.isFinite(i) || i < 0 || i >= WORKSPACE_DETAIL_SECTION_SLUGS.length) {
    return WORKSPACE_DETAIL_SECTION_SLUGS[0];
  }
  return WORKSPACE_DETAIL_SECTION_SLUGS[i];
}

/** Caminho absoluto para um workspace + seção (deep link). */
export function workspaceDetailPath(dominioId, sectionIndexOrSlug) {
  const id = String(dominioId || "").trim();
  if (!id) return PLATFORM_CONSOLE_PATH.workspaces;
  let slug;
  if (typeof sectionIndexOrSlug === "number") {
    slug = workspaceDetailIndexToSection(sectionIndexOrSlug);
  } else {
    const s = String(sectionIndexOrSlug || "").trim().toLowerCase();
    slug = WORKSPACE_DETAIL_SECTION_SLUGS.includes(s) ? s : WORKSPACE_DETAIL_SECTION_SLUGS[0];
  }
  return `${PLATFORM_CONSOLE_BASE}/${PLATFORM_CONSOLE_SEGMENT.workspaces}/${id}/${slug}`;
}
